module.exports = __webpack_public_path__ + "img/08刘海涛.6fd86b5d.png";